import { green } from '@ant-design/colors';
import {
  CheckCircleOutlined,
  EditOutlined,
  EyeOutlined,
  PlusOutlined
} from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';
import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import TableAndFilters from '../../components/TableAndFilters';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';
import { fieldTypes } from '../../utils/filter-utils';

const styles = {
  menuAction: {
    marginLeft: 10
  }
};

function SucursalList(props) {
  const columns = [
    {
      title: 'Código',
      dataIndex: 'codigo',
      width: '20%',
      filterType: fieldTypes.STRING,
      sortable: true
    },
    {
      title: 'Nombre',
      dataIndex: 'descripcion',
      filterType: fieldTypes.STRING,
      sortable: true
    },
    {
      title: 'Dirección',
      dataIndex: 'direccion',
      filterType: fieldTypes.STRING,
      sortable: true
    },
    {
      title: 'Teléfono',
      dataIndex: 'telefono',
      filterType: fieldTypes.STRING,
      sortable: true
    },
    {
      title: 'Acciones',
      key: 'action',
      width: '10px',
      render: (text, record) => (
        <Space size="small">
          <Tooltip title="Ver sucursal">
            <Button
              type="text"
              icon={<EyeOutlined />}
              size="middle"
              onClick={() => handleOpenUrl(`sucursales/view/${record.id}`)}
            />
          </Tooltip>
          <Tooltip title="Editar sucursal">
            <Button
              type="text"
              icon={<EditOutlined />}
              size="middle"
              onClick={() => handleOpenUrl(`sucursales/form/${record.id}`)}
            />
          </Tooltip>
          <Tooltip title={record.activo ? 'Desactivar' : 'Activar'}>
            <Button
              type="text"
              style={record.activo ? { color: green.primary } : {}}
              danger={!record.activo}
              icon={<CheckCircleOutlined />}
              size="middle"
              loading={loadingState === record.id}
              onClick={() => toggle(record)}
            />
          </Tooltip>
        </Space>
      ),
      align: 'center'
    }
  ];

  const [loadingState, setLoadingState] = useState(0);
  const history = useHistory();

  const handleOpenUrl = (url) => {
    history.push(url);
  };

  const toggle = async (record) => {
    try {
      setLoadingState(record.id);
      if (record.activo) {
        await instanceRef.instance.post(`sucursal/disable/${record.id}`, {
          username: record.correo
        });
      } else {
        await instanceRef.instance.post(`sucursal/enable/${record.id}`, {
          username: record.correo
        });
      }
      tableRef.current.reload();
    } catch (error) {
      errorHandler(error);
    }
    setLoadingState(0);
  };

  const tableRef = useRef();

  return (
    <ResponsiveContainer size="large" style={{ paddingTop: 0 }}>
      <div style={{ overflow: 'auto' }}>
        <TableAndFilters
          ref={tableRef}
          withGeneralFilter
          url="/sucursal"
          title="Sucursales"
          columns={columns}
          extra={[
            <Button
              key="2"
              type="dashed"
              shape="round"
              icon={<PlusOutlined />}
              size="middle"
              onClick={() => props.history.push(`sucursales/form`)}
              style={styles.menuAction}
            >
              Agregar
            </Button>
          ]}
        />
      </div>
    </ResponsiveContainer>
  );
}

export default SucursalList;
